import './ThemeBack.css';

export default function ThemeBack() {
    return (
        // This cannot be added in Navbar because them should be behind all elements in <main>, but nav element in at the top of all elements
        <div id="themeBack"></div>
    );
}
